var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTfbank21LogoSymbolWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(216.63 -7.07)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-216.63 7.07)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.367,29.065a12,12,0,1,1,12-12A12.012,12.012,0,0,1,22.367,29.065Zm0-23.43A11.438,11.438,0,1,0,33.805,17.073,11.45,11.45,0,0,0,22.367,5.635Z",
    transform: "translate(-10.37 -5.07)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M30.89,23.981a9.092,9.092,0,0,0-1.031-.84,8.246,8.246,0,0,0-1.171-.625,8.3,8.3,0,0,0,1.209-.663,6.572,6.572,0,0,0,1.042-.867,4.394,4.394,0,0,0,.886-1.282v5.533A4.717,4.717,0,0,0,30.89,23.981Zm-7.23-8.291H18.9v5.037A7.179,7.179,0,0,1,23.659,15.69Zm10.292,5.037V15.69H29.192A7.19,7.19,0,0,1,33.951,20.727ZM28.064,15.69H24.621V30.306h3.443Z",
    transform: "translate(-14.304 -9.995)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTfbank21LogoSymbolWhite);
export default __webpack_public_path__ + "static/media/tfbank21-logo-symbol-white.09b8947dc04f9234e2f3ebdf3211be66.svg";
export { ForwardRef as ReactComponent };